import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import * as authApi from "@/api/auth";
import { useWeb3Actions, useWeb3State } from "@/web3/context";
import useMe from "./useMe";

export default function useWalletSignedFunction(fn: any) {
  const { me } = useMe();
  const { data } = useQuery({
    queryKey: ["token-address-check"],
    queryFn: authApi.verifyTokenWithAddress,
    enabled: !!me,
  });

  const { currentAddress } = useWeb3State();
  const { toggleWalletPicker } = useWeb3Actions();
  return useCallback(
    async (...args: unknown[]) => {
      if (!data?.valid || !currentAddress) {
        toggleWalletPicker();
        return;
      }

      return fn(...args);
    },
    [fn, toggleWalletPicker, currentAddress, data],
  );
}
